import * as Icons from "heroicons-react";
import { signInUser } from "../../Utility/Auth";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import { useEffect, useState } from "react";
import { format } from "date-fns";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useDateWisePurchaseQuery } from "../../../services/reportsApi";
import { useWarehouseQuery } from "../../../services/warehouseApi";
import WareHouseDW from "../../Common/CustomSelect/WareHouseDW";

const DateWisePurchaseReport = () => {
  const auth = signInUser();
  const [warehouse, setWarehouse] = useState("allWh");
  const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [endDate, setEndDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const { aamarId } = auth;
  const lang = useSelector((state) => state.languageReducer);
  const { data: salesData } = useDateWisePurchaseQuery({
    startDate,
    endDate,
    warehouse,
    aamarId,
  });

  // console.log("sale DATA:>:>:", salesData);

  // fine warehouse Name
  const [whName, setWhName] = useState("All Warehouses");
  const { data: wh, refetch } = useWarehouseQuery(warehouse);

  // Call refetch only if user?.warehouse changes
  useEffect(() => {
    if (warehouse) {
      refetch();
    }
  }, [warehouse, refetch]);

  // Update warehouse name when data changes
  useEffect(() => {
    if (wh?.name) {
      setWhName(wh.name); // Directly set the name, no need for optional chaining here
    }
  }, [wh]);
  // console.log("Customer Wise Sales Report Data:", salesData);

  // Export CSV
  const handleExportCSV = () => {
    if (!salesData || salesData.length === 0) {
      alert("No data available for export.");
      return;
    }

    const start = new Date(startDate).toLocaleString();
    const end = new Date(endDate).toLocaleString();
    // const end = salesData[salesData.length - 1]?.createdAt;
    const generatedOn = new Date().toLocaleString();
    const generatedBy = auth?.name || "Aamar Dokan";

    const storeName =
      auth?.storeSettings?.storeName?.toUpperCase() || "Aamar Dokan";
    const warehouseName = whName;
    const reportTitle = "Date Wise Purchase Report";

    const headerInfo = [
      `,Store: ${storeName},,,,,Warehouse: ${warehouseName}`,
      `,Report: ${reportTitle},,,,,Date Range: ${start} to ${end}`,
      `,Generated On: ${generatedOn},,,,Generated By: ${generatedBy}`,
      "",
      "",
    ];

    const csvTableHeader = [
      "S/N",
      "Invoice ID",
      "Date",
      "Supplier Name",
      "Phone",
      "Total Items",
      "PO No",
      "TPN No",
      "Gross Total",
      "Net Amount",
      "Warehouse",
      "Payment Method",
    ].join(",");

    let totalItems = 0;
    let totalGrossTotal = 0;
    let totalNetAmount = 0;

    // CSV Row Data
    const csvRows = salesData.map((row, index) => {
      const items = Number(row?.TotalItems || 0);
      const grossTotal = Number(row?.GrossTotal || 0);
      const netAmount = Number(row?.NetAmount || 0);

      totalItems += items;
      totalGrossTotal += grossTotal;
      totalNetAmount += netAmount;

      return [
        index + 1,
        row?.InvoiceId || "N/A",
        row?.Date || "N/A",
        row?.SupplierName || "N/A",
        row?.SupplierPhone || "N/A",
        row?.TotalItems || 0,
        row?.poNo || "N/A",
        row?.tpnNo || "N/A",
        row?.GrossTotal?.toFixed(2),
        row?.NetAmount?.toFixed(2),
        row?.Warehouse || "N/A",
        row?.PaymentMethod || "Cash",
      ].join(",");
    });

    // Summary Rows
    const summaryLabelRow = [
      "",
      "",
      "",
      "",
      "",
      "",
      "** TOTAL SUMMARY **",
    ].join(",");

    const summaryHeaderRow = [
      "",
      "",
      "",
      "",
      "",
      "Total Items",
      "Gross Total",
      "Net Amount",
    ].join(",");

    const summaryDataRow = [
      "",
      "",
      "",
      "",
      "",
      totalItems,
      totalGrossTotal,
      totalNetAmount,
    ].join(",");

    // CSV Content
    const csvContent = [
      ...headerInfo,
      csvTableHeader,
      ...csvRows,
      "",
      "",
      summaryLabelRow,
      summaryHeaderRow,
      summaryDataRow,
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "DateWisePurchaseReport.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  // export PDF
  const handleExportPDF = () => {
    const doc = new jsPDF("landscape");

    if (salesData?.length === 0) {
      alert("No sales data found.");
      return;
    }

    const options = { month: "numeric", day: "numeric", year: "numeric" };
    const formattedStart = new Date(startDate).toLocaleDateString(
      "en-US",
      options
    );
    const formattedEnd = new Date(endDate).toLocaleDateString("en-US", options);
    const reportGeneratedAt = new Date().toLocaleString();

    const storeName =
      auth?.storeSettings?.storeName?.toUpperCase() || "Aamar Dokan";
    const warehouseName = whName;
    const reportName = "Date Wise Purchase Report";

    // Title
    doc.setFontSize(16);
    doc.text(storeName, 140, 15, { align: "center" });

    doc.setFontSize(12);
    doc.text(reportName, 140, 22, { align: "center" });

    // Header info - Justify between
    doc.setFontSize(10);
    doc.text(`Store: ${storeName}`, 14, 28);
    doc.text(`Warehouse: ${warehouseName}`, 14, 33);
    doc.text(`Date: ${formattedStart} - ${formattedEnd}`, 14, 39);
    // doc.text(`Report: ${reportName}`, 140, 28, { align: "center" });
    doc.text(`Generated At: ${reportGeneratedAt}`, 280, 28, { align: "right" });
    doc.text(`Generated By: ${auth?.name}`, 280, 33, { align: "right" });

    // Table header
    const headers = [
      [
        "S/N",
        "Invoice ID",
        "Date",
        "Supplier Name",
        "Phone",
        "Total Items",
        "PO No",
        "TPN No",
        "Gross Total",
        "Discount",
        "Net Amount",
        "Paid",
        "Due",
        "Warehouse",
        "Payment Method",
      ],
    ];

    const data = salesData?.map((item, index) => [
      index + 1,
      item?.InvoiceId || "N/A",
      item?.Date || "N/A",
      item?.SupplierName || "N/A",
      item?.SupplierPhone || "N/A",
      item?.TotalItems || 0,
      item?.poNo || "N/A",
      item?.tpnNo || "N/A",
      Number(item?.GrossTotal || 0).toFixed(2),
      Number(item?.Discount || 0).toFixed(2),
      Number(item?.NetAmount || 0).toFixed(2),
      Number(item?.PaidAmount || 0).toFixed(2),
      Number(item?.DueAmount || 0).toFixed(2),
      item?.Warehouse || "N/A",
      item?.PaymentMethod || "Cash",
    ]);

    autoTable(doc, {
      head: headers,
      body: data,
      startY: 45,
      theme: "grid",
      styles: {
        fontSize: 7,
        halign: "center",
      },
      headStyles: {
        fillColor: [242, 101, 45], // tomato background
        textColor: [255, 255, 255], // white text
        fontStyle: "bold",
      },
    });
    // === Summary Box ===
    const finalY = doc.lastAutoTable.finalY + 10;
    const lineHeight = 5;
    const boxHeight = 5 * lineHeight + 10;
    const boxWidth = 80;

    const pageWidth = doc.internal.pageSize.getWidth();
    const boxX = pageWidth - boxWidth - 15;
    const boxY = finalY;

    doc.rect(boxX, boxY, boxWidth, boxHeight);

    let y = boxY + 10;
    const labelX = boxX + 5;
    const valueX = boxX + boxWidth - 5;
    doc.setFontSize(9);

    // Calculate totals and percentages
    const totalItems = sumField(salesData, "TotalItems");
    const totalGrossTotal = sumField(salesData, "GrossTotal");
    const totalNetAmount = sumField(salesData, "NetAmount");

    // Render summary
    doc.text("Total Items:", labelX, y);
    doc.text(`${totalItems}`, valueX, y, { align: "right" });

    y += lineHeight;
    doc.text("Total Gross Total:", labelX, y);
    doc.text(`${totalGrossTotal}`, valueX, y, { align: "right" });

    y += lineHeight;
    doc.text("Total Net Amount:", labelX, y);
    doc.text(`${totalNetAmount}`, valueX, y, { align: "right" });

    // Save the PDF
    doc.save("Date_Wise_Purchase_Report.pdf");
  };

  // Utility to sum values from objects
  const sumField = (data, field) =>
    data
      .reduce((acc, item) => acc + (parseFloat(item[field]) || 0), 0)
      .toFixed(2);

  //warehouse
  const handleOnchangeWareHouseFrom = (e) => {
    if (e.option !== "no-warehouse") {
      setWarehouse(e.option);
    } else {
      setWarehouse("allWh");
    }
  };

  return (
    <div>
      <div>
        <h2 className="mb-3">
          <Icons.ShoppingCartOutline size={35} /> User Wise Sales Report
        </h2>
      </div>

      <div
        className="mt-3 w-40 p-3"
        style={{ backgroundColor: "#f1f3f5", borderRadius: "8px" }}
      >
        <div className="d-flex mt-2 mb-2 align-items-center justify-content-center gap-2">
          <DatePicker
            selected={new Date(startDate)}
            className="form-control w-100"
            onChange={(date) =>
              setStartDate(format(new Date(date), "MM-dd-yyyy"))
            }
          />
          <DatePicker
            selected={new Date(endDate)}
            className="form-control me-4"
            onChange={(date) =>
              setEndDate(format(new Date(date), "MM-dd-yyyy"))
            }
          />
        </div>

        <div className="">
          {auth?.type === "admin" && (
            <div className="my-3">
              <WareHouseDW
                id="warehouse"
                name="warehouse"
                handleOnChange={handleOnchangeWareHouseFrom}
                className="form-control"
              />
            </div>
          )}
        </div>

        <div className="d-flex gap-3 justify-content-center align-items-center text-center">
          {/* Download CSV Button */}
          <button
            className="btn btn-dark w-100 mt-3"
            style={{ borderRadius: "5px" }}
            onClick={handleExportCSV}
          >
            <Icons.DownloadOutline size={22} /> Download CSV
          </button>

          {/* Download PDF Button */}
          <button
            className="btn btn-dark w-100 mt-3"
            style={{ borderRadius: "5px" }}
            onClick={handleExportPDF}
          >
            <Icons.DocumentOutline size={22} /> Download PDF
          </button>
        </div>
      </div>
    </div>
  );
};

export default DateWisePurchaseReport;
